// Kind = chip loại từ API /exam-vault/library (deriveKind phía server)
export const KIND_META = {
  exercise: { label: 'Bài tập', unit: 'câu hỏi', icon: 'el-icon-document-checked', color: '#1cab36', bg: '#e8f6eb' },
  vocabulary: { label: 'Từ vựng', unit: 'từ', icon: 'el-icon-reading', color: '#2f6fdb', bg: '#eaf1fd' },
  conversation: { label: 'Hội thoại', unit: 'lượt thoại', icon: 'el-icon-chat-line-square', color: '#c77c0a', bg: '#fdf3e2' },
  video: { label: 'Nộp Video', unit: 'video', icon: 'el-icon-video-camera', color: '#7c3aed', bg: '#f1eafe' },
  writing: { label: 'Luyện viết', unit: 'câu hỏi', icon: 'el-icon-edit', color: '#e0484d', bg: '#fdecec' },
  lesson: { label: 'Bài giảng', unit: 'tài liệu', icon: 'el-icon-monitor', color: '#0d9488', bg: '#e3f5f3' }
}

export const KIND_ORDER = ['exercise', 'vocabulary', 'conversation', 'video', 'writing', 'lesson']

export const OWNER_TABS = [
  { name: 'Group', label: 'Trung tâm' },
  { name: 'School', label: 'Cơ sở' },
  { name: 'Teacher', label: 'Cá nhân' }
]

// Tab hiển thị theo orgCategory, giống trang cũ
export function ownerTabsFor(orgCategory) {
  if (orgCategory === 'school') return OWNER_TABS
  if (orgCategory === 'group') return OWNER_TABS.filter((t) => t.name === 'Group')
  return OWNER_TABS.filter((t) => t.name === 'Teacher')
}

export function canEditOwner(ownerCategory, orgCategory, roles = []) {
  let editable = ['Teacher']
  if (orgCategory === 'school') {
    if (roles.includes('admin') || roles.includes('super_admin')) editable = ['Teacher', 'School']
  } else {
    editable = ['Group']
  }
  return editable.includes(ownerCategory)
}

// Cùng thứ tự ưu tiên với web v2 home/role.ts
export function roleLabel(roles) {
  const list = roles || []
  if (list.includes('group_chief')) return 'Giám đốc trung tâm'
  if (list.includes('department_chief')) return 'Quản lý vùng'
  if (list.includes('admin') || list.includes('super_admin')) return 'Quản lý cơ sở'
  return 'Giáo viên'
}

// serialize() giữ cả null/undefined thành chuỗi -> bỏ trước khi gọi API
export function cleanParams(params) {
  return Object.keys(params).reduce((acc, key) => {
    const value = params[key]
    if (value !== null && value !== undefined && value !== '') acc[key] = value
    return acc
  }, {})
}

export function formatDate(value) {
  if (!value) return '—'
  const d = new Date(value)
  const pad = (n) => String(n).padStart(2, '0')
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
}

// Giỏ gộp thành 1 bài: cùng type, Nộp Video chỉ 1 bài (khớp API /exam-vault/library/homeworks)
export function cartIssue(items) {
  if (items.length < 2) return null
  const type = items[0].type
  if (items.some((item) => item.type !== type)) return 'Chỉ gộp được các bài cùng loại'
  if (type === 'video') return 'Chỉ giao được 1 bài Nộp Video mỗi lần'
  return null
}

export function lastCategoryOf(item) {
  const path = item.categoryPath || []
  return path.length ? path[path.length - 1] : null
}

// Vị trí đang mở (tab / gốc / danh mục) lưu theo tài khoản trên trình duyệt này
const LOCATION_KEY = 'exam-vault-location'

export function loadLocation(userId) {
  try {
    const all = JSON.parse(localStorage.getItem(LOCATION_KEY) || '{}')
    return all[userId] || null
  } catch (e) {
    return null
  }
}

export function saveLocation(userId, location) {
  try {
    const all = JSON.parse(localStorage.getItem(LOCATION_KEY) || '{}')
    all[userId] = location
    localStorage.setItem(LOCATION_KEY, JSON.stringify(all))
  } catch (e) {
    // localStorage bị chặn / đầy -> bỏ qua, chỉ mất tính năng nhớ vị trí
  }
}
